export const environment = {
  production: false,
  environment: "dev",
  ENV: 'DEV',
  maintenanceMode: false,
  subject: "Compare the Market Energy Sign In",
  api_url: 'https://dev.api.perswitch.co.uk/energy-ui',
  api_url_meter: 'https://dev.api.perswitch.co.uk/meter-ui/v1/',
  contact_api_url: 'https://dev.api.perswitch.co.uk/v1/',
  p2s_api: 'https://dev.api.perswitch.co.uk/p2s-ui/v1/',
  home_url: 'https://dev.domestic.perswitch.co.uk/',
  api_url_ev: 'https://dev.api.perswitch.co.uk/evcompare-ui/v1/',
  // api_url_ev: 'https://dev.api.thelabrador.co.uk/evcompare/v1/',
  email_api: 'https://dev.api.perswitch.co.uk/oe-transform-util/v1/',
  dashboard_url: 'https://dashboard.dev.perswitch.co.uk/login',
  login_api: 'https://dev.api.perswitch.co.uk/reporting/v1/',
  lab_v1_url: 'https://api.thelabrador.co.uk/meterhistory/v1/',

  analytics_v1_url: 'https://dev.api.perswitch.co.uk/oe-transform-util/v1',

  ads_url: '/v1/users',
  product_url: '/v1/users/product/productConfig',
  transaction_url: '/v1/users/product/transaction',

  gbgVersion: '2.0',
  gtag: 'UA-103774971-4',
  gtm: 'GTM-KKCBBQB',

  // Gtag for internal tracking
  gtagPerse: 'G-S3KJM7YKKW',

  faq: 'https://www.perswitch.co.uk/faqs',
  netzeroBlog: 'https://netzero.perswitch.co.uk/blog',

  resource_identifier: 'U2FsdGVkX19/0ZXp5zcsE29NfqvV9hMlCh49XNGfJ6YHxWemwCMz27WfHGieI+G/r/o1grazNw5IRjDvSpX4DQ==',

  S3_url: 'https://ctm-content-dev.s3.eu-west-2.amazonaws.com/',

  tealium_account: 'ctm',
  tealium_profile: 'energy-comparison',
  tealium_environment: 'qa',
  tealium_app_name: "EnergyComparison",
  tealium_app_version: "2.1",
  tealium_app_platform: "378ad663-e420-4e0c-a4e6-fadb4cc7c98d",

  isSMCFeature: true,
  isEVFeature: true,
};

export const jwt = {
  authorizeURL: 'https://dev.api.perswitch.co.uk/oauth/authorize'
};
